var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{on:{"click":_vm.downBtn}},[_vm._v("下载")]),_c('div',{attrs:{"id":"test"}},[_c('p',{staticStyle:{"text-align":"center","font-size":"20px"}},[_vm._v("海报图")]),_c('img',{staticClass:"centerImg",attrs:{"src":'https://duole.fznet.top/images/zhengjishejidan1.png',"alt":"","crossorigin":"anonymous"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }